import humps from 'humps'

import { porticoApi } from 'store/porticoApi'

import { TRole } from 'types/roles'
import { TCreatedRoleAssignment } from 'types/accounts'

const roleAssignments = porticoApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoleAssignments: builder.query<TRole[], void>({
      query: () => `operator/role_assignments`,
      providesTags: (result = []) => [
        'RoleAssignments',
        ...result.map(({ uuid }) => ({ type: 'RoleAssignments' as const, id: uuid })),
      ],
    }),
    createRoleAssigment: builder.mutation<TCreatedRoleAssignment[], TCreatedRoleAssignment[]>({
      query: (data) => ({
        url: '/operator/role_assignments',
        method: 'POST',
        body: humps.decamelizeKeys({ role_assignments: data }),
      }),
    }),
    updateRoleAssignment: builder.mutation<TCreatedRoleAssignment[], TCreatedRoleAssignment[]>({
      query: (data) => ({
        url: '/operator/role_assignments',
        method: 'PUT',
        body: humps.decamelizeKeys({ role_assignments: data }),
      }),
    }),
  }),
})

export const {
  useGetRoleAssignmentsQuery,
  useCreateRoleAssigmentMutation,
  useUpdateRoleAssignmentMutation,
} = roleAssignments
